import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "columns" }
const _hoisted_2 = {
  key: 0,
  class: "column is-4 friDeviceCol1"
}
const _hoisted_3 = {
  class: "account-box is-navigation p-0 mt-0",
  style: {"border":"none !important"}
}
const _hoisted_4 = { class: "account-menu me-5" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-user-alt"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-compact-left fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Volver")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  class: "column is-8 ps-0",
  id: "friDeviceCol2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanDash = _resolveComponent("PlanDash")!
  const _component_Payment = _resolveComponent("Payment")!
  const _component_Docs = _resolveComponent("Docs")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["account-wrapper text-left", _ctx.isMobile ? '': 'mt-5'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.sections, (section, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["account-menu-item cursor-pointer", _ctx.layout.section == section.name ? 'router-link-active router-link-exact-active' : '']),
                    onClick: ($event: any) => (_ctx.$router.push({ path: '/plan/' + _ctx.layout.clientId + '/' + _ctx.layout.planId , query: { section:  section.name } }))
                  }, [
                    _hoisted_6,
                    _createElementVNode("span", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(section.icon + ' fs-3 align-middle me-3')
                      }, null, 2),
                      _createTextVNode(_toDisplayString(section.title), 1)
                    ]),
                    _hoisted_7
                  ], 10, _hoisted_5))
                }), 128)),
                _createElementVNode("div", {
                  class: "account-menu-item mt-2 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
                }, _hoisted_11)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.layout.section == 'dashboard')
          ? (_openBlock(), _createBlock(_component_PlanDash, {
              key: 0,
              clientId: _ctx.layout.clientId,
              planId: _ctx.layout.planId,
              isMobile: _ctx.isMobile
            }, null, 8, ["clientId", "planId", "isMobile"]))
          : _createCommentVNode("", true),
        (_ctx.layout.section == 'payment')
          ? (_openBlock(), _createBlock(_component_Payment, {
              key: 1,
              clientId: _ctx.layout.clientId,
              planId: _ctx.layout.planId,
              isMobile: _ctx.isMobile
            }, null, 8, ["clientId", "planId", "isMobile"]))
          : _createCommentVNode("", true),
        (_ctx.layout.section == 'documents')
          ? (_openBlock(), _createBlock(_component_Docs, {
              key: 2,
              clientId: _ctx.layout.clientId,
              planId: _ctx.layout.planId,
              isMobile: _ctx.isMobile
            }, null, 8, ["clientId", "planId", "isMobile"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}